class ResourceTemplate {
	constructor(el) {
		this.el = el;
		this.featuredResourceEl = this.el.querySelector('.resource__featured-resource');
		this.featuredResourceRow = this.el.querySelector('.resource__featured-resource-row');
		this.featuredId = this.featuredResourceRow.dataset.featuredId;
		this.baseUrl = window.location.origin;

		this.displayFeatured();
	}

	displayFeatured = () => {
		window.almComplete = () => {
			const ajaxLoadMoreListing = document.querySelector('.alm-listing');
			const almFilters = ajaxLoadMoreListing.querySelector('.alm-filters');
			const cards = ajaxLoadMoreListing.querySelectorAll('.card');

			if (!almFilters) return;

			if (almFilters.dataset.url === this.baseUrl + '/resource/') {
				this.featuredResourceRow.classList.remove('hidden');
			} else {
				this.featuredResourceRow.classList.add('hidden');
			}

			cards.forEach((card) => {
				if (
					card.dataset.postId === this.featuredId &&
					almFilters.dataset.url === this.baseUrl + '/resource/'
				) {
					card.classList.add('hidden');
				}
			});
		};
	};
}

export default ResourceTemplate;
